import { useMutation } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

import { axios } from "@/client/libs/axios";

export const uploadImage = (file: File) => {
  const formData = new FormData();
  formData.append("file", file);

  return axios.put<string, AxiosResponse<string>, FormData>("/storage/image/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

/** Unauthenticated upload with IP rate limit; for temporary builder resumes. */
export const uploadTemporaryImage = (file: File) => {
  const formData = new FormData();
  formData.append("file", file);

  return axios.put<string, AxiosResponse<string>, FormData>(
    "/storage/image/upload/temp",
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    },
  );
};

export const useUploadImage = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: uploadImageFn,
  } = useMutation({
    mutationFn: uploadImage,
  });

  return { uploadImage: uploadImageFn, loading, error };
};

export const useUploadTemporaryImage = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: uploadTemporaryImageFn,
  } = useMutation({
    mutationFn: uploadTemporaryImage,
  });

  return { uploadTemporaryImage: uploadTemporaryImageFn, loading, error };
};
